import * as React from 'react';
import { Card, CardActions, CardContent } from 'ui';
import { consumer } from '@tock/coretypes';
import { isOfferingEventType } from 'utils/offerings';
import {
  offeringDetailsSimpleActions,
  offeringDetailsSimpleContent,
  offeringDetailsSimpleCtaTimes,
  offeringDetailsSimpleRoot,
} from 'components/business/offering/offeringCssDefs';
import EventOfferingDetailsSimple from 'components/business/offering/EventOfferingDetailsSimple';
import ExperienceOfferingDetailsSimple from 'components/business/offering/ExperienceOfferingDetailsSimple';

export interface Props {
  business: consumer.IBusinessConfig;
  offering: consumer.Offering;
  onNavigateToExperience?(event: consumer.Offering, nextAvailableDate?: string): void;
  ctaType: 'CTA' | 'TIMES';
  cta: React.ReactNode;
}

const OfferingDetailsSimple: React.FunctionComponent<Props> = ({
  business,
  offering,
  onNavigateToExperience,
  ctaType,
  cta,
}) => {
  const isEvent = isOfferingEventType(offering);
  return (
    <Card css={offeringDetailsSimpleRoot} elevation={0} variant="outlined">
      <CardContent css={offeringDetailsSimpleContent}>
        {isEvent && (
          <EventOfferingDetailsSimple
            offering={offering}
            business={business}
            onNavigateToExperience={onNavigateToExperience}
            hideLocation
          />
        )}
        {!isEvent && (
          <ExperienceOfferingDetailsSimple
            offering={offering}
            businessType={business.businessType ?? undefined}
            onNavigateToExperience={onNavigateToExperience}
          />
        )}
      </CardContent>
      <CardActions css={offeringDetailsSimpleActions}>
        <div css={ctaType === 'TIMES' && offeringDetailsSimpleCtaTimes}>{cta}</div>
      </CardActions>
    </Card>
  );
};

export default OfferingDetailsSimple;
